import { Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent, IconComponent, PageLayoutComponent, SpinnerComponent } from '@sarasanalytics-com/design-system';
import { Token } from 'src/app/app.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CookiesService } from 'src/app/services/cookies/cookies.service';
import { MfaService } from 'src/app/services/mfa/mfa.service';
import { RedirectionService } from 'src/app/services/redirection/redirection.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import { StoreService } from 'src/app/services/store/store.service';
import { OtpComponent } from 'src/app/shared/components/otp/otp.component';
import { API_ERRORS } from 'src/app/static/api.constant';

@Component({
  selector: 'app-mfa-verification',
  standalone: true,
  imports: [IconComponent,PageLayoutComponent,ButtonComponent, OtpComponent, SpinnerComponent],
  templateUrl: './mfa-verification.component.html',
  styleUrl: './mfa-verification.component.scss'
})
export class MfaVerificationComponent {
  @ViewChild(OtpComponent, { static: false }) otpComponent: OtpComponent;

  showSpinner: boolean = false;
  
  checkingOTP: boolean = false;
  userData: any;
  private mfaService: MfaService = inject(MfaService);
  private signupService: SignupService = inject(SignupService);
  private authService: AuthService = inject(AuthService);
  private cookieService: CookiesService = inject(CookiesService);
  private redirectionService: RedirectionService = inject(RedirectionService);
  private store: StoreService = inject(StoreService);
  private router: Router = inject(Router);

  public status: null | 'success' | 'failure' = null;
  public errorMsg: string = '';

  ngOnInit(){
    if(!this.mfaService.mfaResolver){
      this.router.navigate(['/login']);
    }
  }

  onOTPChange(value: any){
    this.status = 'success';
    this.errorMsg = '';
    if(value.length === 6){
      this.checkingOTP = true;

      this.mfaService.verifyMfaCode(value)
      .then((result: any)=>{
        this.userData = result.user;
        return result.user.getIdTokenResult();
      }).then((idTokenResult)=>{
        this.signupService
            .verifyFirebaseToken(idTokenResult.token)
            .subscribe((res: any)=>{
              if(res.success && res.data){
                const token: Token = res.data;
                const userId = token?.userId;

                this.authService.globalAuthInitialized = true;
  
                /* GET USER DATA */
                this.signupService.getUserInfo(userId).subscribe((userInfoRes)=>{
                  this.checkingOTP = false;
                  if(userInfoRes.success && userInfoRes.data){
                    this.cookieService.addSharedCookie(token);
                    this.store.setSarasPortalData('LOGIN');
                    this.showSpinner = true;
                    this.redirectionService.redirectToProduct();
                  }
                })
                
              }else{
                // this.handleErrors(res);
              }
            })    
      }).catch((err)=>{
        console.log(err);
        this.checkingOTP = false;
        this.otpVerificationError(err);
      })
      // setTimeout(()=>{
      //   this.checkingOTP = false;
      // }, 2000);
    }
  }

  otpVerificationError(error: any){
    if(error?.code){
      switch (error.code) {
        case API_ERRORS.FIREBASE_CODES.MFA_INVALID_CODE:
          this.status = 'failure';
          this.errorMsg = API_ERRORS.FIREBASE_MESSAGES.MFA_INVALID_CODE;
          break;
        case API_ERRORS.FIREBASE_CODES.MFA_TOTP_TIMEOUT:
          this.status = 'failure';
          this.errorMsg = API_ERRORS.FIREBASE_MESSAGES.MFA_TOTP_TIMEOUT;
          break;
        default:
          this.status = 'failure';
          this.errorMsg = (API_ERRORS.FIREBASE_MESSAGES as any)[error.code] || API_ERRORS.FIREBASE_MESSAGES.DEFAULT;
          this.otpComponent.resetValue();
          break;
      }
    }else{
      this.status = 'failure';
      this.errorMsg = API_ERRORS.FIREBASE_MESSAGES.DEFAULT;
      this.otpComponent.resetValue();
    }
  }
}
